$(document).ready(function() {
  $('#current_company_id').on('change', function() {
    var companyId = $(this).val();
    if (!companyId) return;

    $.ajax({
      url: '/cashback_rates/rates_for_company',
      method: 'GET',
      data: { company_id: companyId },
      success: function(data) {
        var baseRateSelect = $('select[id*="base_rate_id"]');
        var baseRateHidden = $('input[id*="base_rate_id"][type="hidden"]');
        var specialRateSelect = $('select[id*="special_rate_id"]');

        baseRateSelect.empty();
        if (data.base_rate) {
          baseRateSelect.append('<option value="' + data.base_rate.id + '">' + data.base_rate.display_text + '</option>');
          baseRateHidden.val(data.base_rate.id);
        }

        specialRateSelect.empty().append('<option value="">Select Special Rate (Optional)</option>');
        if (data.special_rates && data.special_rates.length > 0) {
          data.special_rates.forEach(function(rate) {
            specialRateSelect.append('<option value="' + rate.id + '">' + rate.display_text + '</option>');
          });
        }
      }
    });
  });
});
